import { connect } from "react-redux";
import { GetState } from "../../config/store";
import ChatWidget from "../../components/ChatWidget/ChatWidget";
import { sendMessage, sendHiddenContextMessage, closeChat, clearMessages, sendConversationFeedback } from "../../actions/chat";

const mapStateToProps = (state: ReturnType<GetState>) => {
    const hasError = state.chat.fetching === 'failure';

    return {
        isOpen: state.chat.isOpen,
        messages: state.chat.messages,
        isTyping: state.chat.isTyping,
        disabled: state.chat.fetching === 'loading' || hasError,
        hasError,
        user: (state as any).auth?.user || null,
        caseId: state.chat.caseId,
        feedbackSent: state.chat.feedbackSent,
        feedbackLiked: state.chat.feedbackLiked,
    };
};

const mapDispatchToProps = (dispatch: any) => ({
    onClose: () => dispatch(closeChat()),
    onRefresh: () => dispatch(clearMessages()),
    onSendMessage: (message: string) => {
        return (dispatch as any)((dispatch: any, getState: any) => {
            const caseId = getState().chat.caseId;
            dispatch(sendMessage(message, caseId));
        });
    },
    onSendHiddenContext: (contextMessage: string, caseId: string) => {
        return dispatch(sendHiddenContextMessage(contextMessage, caseId));
    },
    onSendFeedback: (caseId: string, liked: boolean) => {
        return dispatch(sendConversationFeedback(caseId, liked));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatWidget);
